import React, { useEffect, useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { differenceInDays } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import {
    useTheme
} from "native-base";

import RichTextEditor, { EditorValue } from 'react-rte';

import { Doughnut } from 'react-chartjs-2';

import poweredByStripe from "./../../../assets/images/poweredByStripeBlack.svg"

// mui
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LinearProgress from '@mui/material/LinearProgress'
import InputAdornment from '@mui/material/InputAdornment'
import Checkbox from '@mui/material/Checkbox'
import { ColorPicker, ColorValue } from 'mui-color';
import FontPicker from "font-picker-react";
import { Font } from "@samuelmeuli/font-manager"

import { useDropzone } from 'react-dropzone'

import ManageCampaignDialog from './../../../components/dialogs/fundraising/ManageCampaignDialog'

import { useAppSelector, useAppDispatch } from '../../../hooks'
import { reloadAuthAccount } from '../../../managers/redux/slices/authAccount'
import { setSelectedFundraisingCampaign, updatePublicFundraisingCampaignDetails, getFundraisingCampaignAmbassadors, getFundraisingCampaignUpdates, setSelectedCampaignUpdate } from '../../../managers/redux/slices/fundraising'

import { FundraisingCampaign, Organization, FundraisingProfile, FundraisingCampaignAmbassador, FundraisingCampaignAmbassadorContact, FundraisingCampaignType, FollowUpResponse, FundraisingCampaignUpdate, FundraisingCampaignAmbassadorStatus } from '../../../API'
import { Box, Button, Select, TextField, Typography, MenuItem } from '@mui/material';
import { API, Storage, Auth } from 'aws-amplify';
import AWS from 'aws-sdk'
import { updateFundraisingCampaign } from '../../../managers/graphql/mutations';
import { toast } from 'react-toastify';

export default function CampaignPage(props: any) {

    const { colors } = useTheme()
    const dispatch = useAppDispatch()

    const [fundraisingCampaignIntro, setFundraisingCampaignIntro] = useState<EditorValue | null>(null)
    const [publicVideoID, setPublicVideoID] = useState<string | null>(null)
    const [publicVideoProvider, setPublicVideoProvider] = useState<string | null>(null)
    const [progressChartType, setProgressChartType] = useState<string | null>(null)
    const [fundraisingCampaignDescription, setFundrasingCampaignDescription] = useState<EditorValue | null>(null)
    const [primaryColor, setPrimaryColor] = useState<any>(undefined)
    const [secondaryColor, setSecondaryColor] = useState<any>(undefined)
    const [buttonColor, setButtonColor] = useState<any>(undefined)
    const [buttonTextColor, setButtonTextColor] = useState<any>(undefined)
    const [headerSelectedFont, setHeaderSelectedFont] = useState<Font | undefined>(undefined)
    const [bodySelectedFont, setBodySelectedFont] = useState<Font | undefined>(undefined)
    const [layout, setLayout] = useState<string>('layout1')

    const [headerImage, setHeaderImage] = useState<string | null>(null)
    const [changeHeaderImage, setChangeHeaderImage] = useState<boolean>(false)

    const [changeLogoImage, setChangeLogoImage] = useState<boolean>(false)
    const [profileImage, setProfileImage] = useState<string | null>(null)


    const [showManageCampaignDialog, setShowManageCampaignDialog] = useState<boolean>(false)

    const selectedFundraisingCampaign = useAppSelector(state => state.fundraising.selectedCampaign)
    const authAccount = useAppSelector(state => state.authAccount)

    useEffect(() => {
        (async () => {

            var _selectedFundraisingCampaign: FundraisingCampaign | null = null

            if (authAccount.cognitoData == null) {
                await dispatch(reloadAuthAccount())

                const queryParams = queryString.parse(window.location.search)
                console.log(queryParams)

                if (queryString.parse(window.location.search).id) {
                    const getSelectedCampaignResponse = await dispatch(setSelectedFundraisingCampaign({
                        id: queryString.parse(window.location.search).id
                    }))

                    if (getSelectedCampaignResponse.payload && getSelectedCampaignResponse.payload.fundraisingCampaign) {
                        _selectedFundraisingCampaign = getSelectedCampaignResponse.payload.fundraisingCampaign

                        dispatch(getFundraisingCampaignAmbassadors({ campaignId: queryString.parse(window.location.search).id }))
                        dispatch(getFundraisingCampaignUpdates({ campaignId: queryString.parse(window.location.search).id }))
                    }
                }
            } else {
                const queryParams = queryString.parse(window.location.search)
                console.log(queryParams)

                if (queryParams.id) {
                    const getSelectedCampaignResponse = await dispatch(setSelectedFundraisingCampaign({
                        id: queryParams.id
                    }))

                    if (getSelectedCampaignResponse.payload && getSelectedCampaignResponse.payload.fundraisingCampaign) {
                        _selectedFundraisingCampaign = getSelectedCampaignResponse.payload.fundraisingCampaign

                        dispatch(getFundraisingCampaignAmbassadors({ campaignId: queryParams.id }))
                        dispatch(getFundraisingCampaignUpdates({ campaignId: queryParams.id }))
                    }
                }
            }

            if (_selectedFundraisingCampaign) {
                setPublicVideoID(_selectedFundraisingCampaign.publicVideoID ? _selectedFundraisingCampaign.publicVideoID : null)
                setPublicVideoProvider(_selectedFundraisingCampaign.publicVideoProvider ? _selectedFundraisingCampaign.publicVideoProvider : null)
                setFundraisingCampaignIntro(_selectedFundraisingCampaign.publicCampaignIntro ? EditorValue.createFromString(_selectedFundraisingCampaign.publicCampaignIntro, 'html') : null)
                setFundrasingCampaignDescription(_selectedFundraisingCampaign.publicCampaignAbout ? EditorValue.createFromString(_selectedFundraisingCampaign.publicCampaignAbout, 'html') : null)
                setProgressChartType(_selectedFundraisingCampaign.progressChartType ? _selectedFundraisingCampaign.progressChartType : null)
                setPrimaryColor(_selectedFundraisingCampaign.primaryColor ? JSON.parse(_selectedFundraisingCampaign.primaryColor) : undefined)
                setSecondaryColor(_selectedFundraisingCampaign.secondaryColor ? JSON.parse(_selectedFundraisingCampaign.secondaryColor) : undefined)
                setButtonColor(_selectedFundraisingCampaign.buttonBackgroundColor ? JSON.parse(_selectedFundraisingCampaign.buttonBackgroundColor) : undefined)
                setButtonTextColor(_selectedFundraisingCampaign.buttonTextColor ? JSON.parse(_selectedFundraisingCampaign.buttonTextColor) : undefined)
                if (_selectedFundraisingCampaign.headerFont) setHeaderSelectedFont(JSON.parse(_selectedFundraisingCampaign.headerFont))
                if (_selectedFundraisingCampaign.bodyFont) setBodySelectedFont(JSON.parse(_selectedFundraisingCampaign.bodyFont))
                if (_selectedFundraisingCampaign.customHeaderImageUploaded) {
                    const uri = await Storage.get(`campaigns/${_selectedFundraisingCampaign.id}/headerImage`)
                    setHeaderImage(uri)
                } else {
                    const uri = await Storage.get(`organizations/${_selectedFundraisingCampaign.organizationID}/headerImage`)
                    setHeaderImage(uri)
                }
                if (_selectedFundraisingCampaign.customLogoImageUploaded) {
                    const uri = await Storage.get(`campaigns/${_selectedFundraisingCampaign.id}/logoImage`)
                    setProfileImage(uri)
                } else {
                    const uri = await Storage.get(`organizations/${_selectedFundraisingCampaign.organizationID}/profilePicture`)
                    setProfileImage(uri)
                }
            }
        })()
    }, [])

    const onDropHeaderImage = useCallback(async acceptedFiles => {
        // Do something with the files
        console.log(acceptedFiles[0])
        try {
            if (queryString.parse(window.location.search).id) {
                await Storage.put(`campaigns/${queryString.parse(window.location.search).id}/headerImage`, acceptedFiles[0], {
                    contentType: acceptedFiles[0].type
                })
                await Auth.currentCredentials()
                    .then(credentials => {
                        const s3 = new AWS.S3({ credentials: Auth.essentialCredentials(credentials), apiVersion: '2006-03-01' })
                        const upload = s3.upload({ Bucket: 'public-flourish-assets', Key: `campaigns/${queryString.parse(window.location.search).id}/headerImage`, Body: acceptedFiles[0] })
                        upload.send()
                    })
                const { data }: any = await API.graphql({
                    query: updateFundraisingCampaign,
                    variables: {
                        input: {
                            id: queryString.parse(window.location.search).id,
                            customHeaderImageUploaded: true
                        }
                    }
                })
                const uri = await Storage.get(`campaigns/${queryString.parse(window.location.search).id}/headerImage`)
                setHeaderImage(uri)
                console.log(data)
                setChangeHeaderImage(false)
            }
        } catch (err) {
            console.log(err)
        }
    }, [])

    const onDropProfileImage = useCallback(async acceptedFiles => {
        // Do something with the files
        console.log(acceptedFiles[0])
        try {
            if (queryString.parse(window.location.search).id) {
                await Storage.put(`campaigns/${queryString.parse(window.location.search).id}/logoImage`, acceptedFiles[0], {
                    contentType: acceptedFiles[0].type
                })
                await Auth.currentCredentials()
                    .then(credentials => {
                        const s3 = new AWS.S3({ credentials: Auth.essentialCredentials(credentials), apiVersion: '2006-03-01' })
                        const upload = s3.upload({ Bucket: 'public-flourish-assets', Key: `campaigns/${queryString.parse(window.location.search).id}/logoImage`, Body: acceptedFiles[0] })
                        upload.send()
                    })
                const { data }: any = await API.graphql({
                    query: updateFundraisingCampaign,
                    variables: {
                        input: {
                            id: queryString.parse(window.location.search).id,
                            customLogoImageUploaded: true
                        }
                    }
                })
                const uri = await Storage.get(`campaigns/${queryString.parse(window.location.search).id}/logoImage`)
                setProfileImage(uri)
                console.log(data)
                setChangeLogoImage(false)
            }
        } catch (err) {
            console.log(err)
        }
    }, [])

    const headerImageDropzone = useDropzone({ maxFiles: 1, accept: 'image/jpeg,image/png', onDrop: onDropHeaderImage, maxSize: 5242880 })
    const headerImageAcceptedFiles = headerImageDropzone.acceptedFiles
    const headerImageRootProps = headerImageDropzone.getRootProps
    const headerImageInputProps = headerImageDropzone.getInputProps
    const headerImageIsDragActive = headerImageDropzone.isDragActive

    const profilePictureDropzone = useDropzone({ maxFiles: 1, accept: 'image/jpeg,image/png', onDrop: onDropProfileImage, maxSize: 5242880 })
    const profilePictureAcceptedFiles = profilePictureDropzone.acceptedFiles
    const profilePictureRootProps = profilePictureDropzone.getRootProps
    const profilePictureInputProps = profilePictureDropzone.getInputProps
    const profilePictureIsDragActive = profilePictureDropzone.isDragActive

    return (
        <div className="container-fluid p-0">
            <div className="row mt-1 p-0 g-0">
                <div className="col-12 w-100 d-flex flex-row justify-content-between align-items-center px-5 mb-3">
                    <Select
                        value={layout}
                        label="Layout"
                        onChange={(e) => { setLayout(e.target.value) }}
                    >
                        <MenuItem value={'layout1'}>Layout 1</MenuItem>
                        <MenuItem value={'layout2'}>Layout 2</MenuItem>
                    </Select>
                    <div className="d-flex flex-row justify-content-center">
                        <a href={`https://latent.flourishos.com/campaign?id=${selectedFundraisingCampaign ? selectedFundraisingCampaign.id : ''}`} target="_blank" style={{ textDecoration: 'none' }}>
                            <Button variant="outlined"
                                className="px-5 mx-3"
                            >
                                Preview
                            </Button>
                        </a>
                        <Button variant="contained"
                            className="px-5"
                            onClick={() => {
                                dispatch(updatePublicFundraisingCampaignDetails({
                                    publicVideoID: publicVideoID,
                                    publicVideoProvider: publicVideoProvider,
                                    progressChartType: progressChartType,
                                    publicCampaignAbout: fundraisingCampaignDescription ? fundraisingCampaignDescription.toString('html') : null,
                                    publicCampaignIntro: fundraisingCampaignIntro ? fundraisingCampaignIntro.toString('html') : null,
                                    primaryColor: primaryColor && primaryColor.hex ? JSON.stringify(primaryColor) : null,
                                    buttonBackgroundColor: buttonColor && buttonColor.hex ? JSON.stringify(buttonColor) : null,
                                    buttonTextColor: buttonTextColor && buttonTextColor.hex ? JSON.stringify(buttonTextColor) : null,
                                    secondaryColor: secondaryColor && secondaryColor.hex ? JSON.stringify(secondaryColor) : null,
                                    headerFont: headerSelectedFont ? JSON.stringify(headerSelectedFont) : null,
                                    bodyFont: bodySelectedFont ? JSON.stringify(bodySelectedFont) : null
                                }))
                            }}
                        >
                            Save
                        </Button>
                    </div>
                </div>
                {
                    layout == 'layout1' &&
                    <div className="row g-0 p-0">
                        <div style={{
                            backgroundColor: primaryColor && primaryColor.hex ? `#${primaryColor.hex}` : '#00C3A0',
                        }}>
                            <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Bebas+Neue"></link>
                            <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Montserrat"></link>
                            <div className="container-fluid p-0">
                                <div className="row p-0 g-0">
                                    <div className="col-12 col-lg-6 h-auto d-flex flex-column justify-content-center align-items-start p-3 p-lg-5 m-0 sticky-top" style={{ maxHeight: '100vh', zIndex: 0 }}>
                                        <div className="col-12 d-flex flex-row justify-content-center align-items-center h-auto bg-white p-2 rounded shadow mb-3">
                                            <Typography className="mx-3">Background color</Typography>
                                            <ColorPicker hideTextfield disableAlpha value={primaryColor} onChange={(e) => { setPrimaryColor(e); console.log(e) }} />
                                        </div>
                                        <div className="col-12 d-flex flex-column justify-content-center align-items-center h-auto bg-white p-3 p-lg-5 rounded shadow">
                                            <div className="d-flex flex-row justify-content-center d-lg-none">
                                                <img
                                                    src={''}
                                                    style={{
                                                        objectFit: 'contain',
                                                        width: '50%',
                                                        height: 100,
                                                        opacity: 1,
                                                        alignSelf: 'center'
                                                    }}
                                                />
                                            </div>
                                            <Typography variant="h1" className="mt-3 apply-font-header">{selectedFundraisingCampaign && selectedFundraisingCampaign.campaignName ? selectedFundraisingCampaign.campaignName : ''}</Typography>
                                            {/* <Typography my="2" variant="body1">{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}
                                            <Typography variant="h4" className="my-3 apply-font-body">Campaign ends {selectedFundraisingCampaign && selectedFundraisingCampaign.campaignEndDate ? formatInTimeZone(new Date(selectedFundraisingCampaign.campaignEndDate), "UTC", 'EEEE, LLLL do') : ''} {selectedFundraisingCampaign && selectedFundraisingCampaign.campaignEndDate ? differenceInDays(new Date(selectedFundraisingCampaign.campaignEndDate), new Date()) >= 0 ? `(${differenceInDays(new Date(selectedFundraisingCampaign.campaignEndDate), new Date())} days away)` : `(${Math.abs(differenceInDays(new Date(selectedFundraisingCampaign.campaignEndDate), new Date()))} days ago)` : 'ERROR'}</Typography>
                                            <div className="row g-0 w-100">
                                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center">
                                                    {
                                                        selectedFundraisingCampaign && selectedFundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                                            <div className="row">
                                                                <div className="col-6 col-lg-3">
                                                                    <div>
                                                                        ${selectedFundraisingCampaign.givingCircleBaseAmount ? selectedFundraisingCampaign.givingCircleBaseAmount : 10}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <TextField disabled label="Donation amount" className="m-0" type="number" fullWidth InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }} />

                                                    }
                                                </div>
                                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-center align-items-center my-2">
                                                    <FormControlLabel disabled control={<Checkbox />} label="Make donation anonymous" />
                                                </div>
                                            </div>
                                            <div className="d-flex flex-row justify-content-start align-items-center my-2 w-100">
                                                <TextField disabled fullWidth label="Donor name" />
                                            </div>
                                            <div className="col-12 d-flex flex-row justify-content-center align-items-center h-auto p-2">
                                                <Typography className="mx-3">Button color</Typography>
                                                <ColorPicker hideTextfield disableAlpha value={buttonColor} onChange={(e) => { setButtonColor(e); console.log(e) }} />
                                            </div>
                                            <div className="col-12 d-flex flex-row justify-content-center align-items-center h-auto p-2">
                                                <Typography className="mx-3">Button text color</Typography>
                                                <ColorPicker hideTextfield disableAlpha value={buttonTextColor} onChange={(e) => { setButtonTextColor(e); console.log(e) }} />
                                            </div>
                                            <Button className="my-3" style={{ backgroundColor: buttonColor && buttonColor.hex ? `#${buttonColor.hex}` : '#E4BB00', borderColor: colors.primary[600], color: buttonTextColor && buttonTextColor.hex ? `#${buttonTextColor.hex}` : 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }}
                                                onClick={async () => {

                                                }}
                                            >
                                                DONATE
                                            </Button>
                                            <img
                                                src={poweredByStripe}
                                                style={{
                                                    objectFit: 'contain',
                                                    width: 200,
                                                    height: 30,
                                                    opacity: 1,
                                                    alignSelf: 'center'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row bg-white shadow p-0 g-0" style={{ zIndex: 5 }}>
                                        {
                                            selectedFundraisingCampaign ?
                                                <div className="col-12 d-flex flex-column justify-content-center align-items-center mb-2 bg-light" style={{ position: 'relative' }}>
                                                    <Box className="rounded w-100" sx={{ ":hover": { backgroundColor: 'gray', opacity: 0.5, cursor: 'pointer' } }}>
                                                        {
                                                            !changeHeaderImage ?
                                                                <img
                                                                    src={headerImage ? headerImage : ''}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        maxWidth: '100%',
                                                                        width: '100%',
                                                                        height: 300,
                                                                        opacity: 0.4,
                                                                    }}
                                                                    className="hover-overlay"
                                                                />
                                                                :
                                                                <div {...headerImageRootProps({ className: 'dropzone h-100 w-100 d-flex flex-column justify-content-center align-items-center' })} style={{ minHeight: 300 }}>
                                                                    <input {...headerImageInputProps()} />
                                                                    {
                                                                        headerImageIsDragActive ?
                                                                            <p style={{ width: '100%', textAlign: 'center' }}>Drop the file here</p>
                                                                            :
                                                                            <p style={{ width: '100%', textAlign: 'center' }}>Drag an image here, or click to select a file.</p>
                                                                    }
                                                                </div>
                                                        }
                                                    </Box>
                                                    <Box className="" sx={{ position: 'absolute' }}>
                                                        {
                                                            !changeHeaderImage && !changeLogoImage ?
                                                                <div className="d-flex flex-column justify-content-center align-items-center">
                                                                    <img
                                                                        src={profileImage ? profileImage : ''}
                                                                        style={{
                                                                            objectFit: 'contain',
                                                                            width: 600,
                                                                            height: 100,
                                                                            opacity: 1,
                                                                        }}
                                                                    />
                                                                    {/* <Typography my="2" variant="h1" className="mx-4" style={{ color: 'black', fontSize: 70 }}>{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}

                                                                </div>
                                                                :
                                                                !changeHeaderImage && changeLogoImage ?
                                                                    <div {...profilePictureRootProps({ className: 'dropzone h-100 w-100 d-flex flex-column justify-content-center align-items-center' })} style={{ minHeight: 100 }}>
                                                                        <input {...profilePictureInputProps()} />
                                                                        {
                                                                            headerImageIsDragActive ?
                                                                                <p style={{ width: '100%', textAlign: 'center' }}>Drop the file here</p>
                                                                                :
                                                                                <p style={{ width: '100%', textAlign: 'center' }}>Drag an image here, or click to select a file.</p>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div></div>
                                                        }
                                                    </Box>
                                                </div>
                                                :
                                                <div></div>
                                        }
                                        <div className="col-12 d-flex flex-row justify-content-around align-items-center">
                                            <Button variant="outlined" onClick={() => { setChangeHeaderImage((_changeHeaderImage) => !_changeHeaderImage) }}>{changeHeaderImage ? 'Cancel' : 'Change Header Image'}</Button>
                                            <Button variant="outlined" onClick={() => { setChangeLogoImage((_changeLogoImage) => !_changeLogoImage) }}>{changeLogoImage ? 'Cancel' : 'Change Logo Image'}</Button>
                                        </div>
                                        <div className="col-12 d-flex flex-column justify-content-start p-5" style={{ fontFamily: 'Montserrat' }}>
                                            <RichTextEditor
                                                value={fundraisingCampaignIntro ? fundraisingCampaignIntro : EditorValue.createEmpty()}
                                                onChange={(e) => setFundraisingCampaignIntro(e)}
                                                rootStyle={{ minHeight: '150px' }}
                                                className="apply-font-body"
                                            />
                                        </div>
                                        <div className="col-12">
                                            <div className="d-flex flex-row justify-content-center align-items-center">
                                                <RadioGroup
                                                    row
                                                    value={publicVideoProvider}
                                                    onChange={(e, value) => { setPublicVideoProvider(value) }}
                                                    className="my-3"
                                                >
                                                    <FormControlLabel value="none" control={<Radio />} label="No Video" />
                                                    <FormControlLabel value="youtube" control={<Radio />} label="Youtube" />
                                                    <FormControlLabel value="vimeo" control={<Radio />} label="Vimeo" />
                                                </RadioGroup>
                                                {
                                                    (publicVideoProvider == 'youtube' || publicVideoProvider == 'vimeo') &&
                                                    <TextField label="Video ID" value={publicVideoID} onChange={(e) => setPublicVideoID(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="col-12 d-flex flex-row justify-content-center">
                                            {
                                                publicVideoProvider == 'youtube' ?
                                                    <iframe
                                                        src={`https://www.youtube.com/embed/${publicVideoID ? publicVideoID : ''}`}
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                        title="Embedded youtube"
                                                        style={{ width: '75%', maxHeight: '300px', height: '300px' }}
                                                    />
                                                    :
                                                    publicVideoProvider == 'vimeo' ?
                                                        <iframe
                                                            src={`https://player.vimeo.com/video/${publicVideoID ? publicVideoID : ''}`}
                                                            frameBorder="0"
                                                            allow="autoplay; fullscreen; picture-in-picture"
                                                            allowFullScreen
                                                            title="Embedded vimeo"
                                                            style={{ width: '75%', maxHeight: '300px', height: '300px' }}
                                                        />
                                                        :
                                                        <div></div>
                                            }
                                        </div>
                                        <div className="col-12 mt-3">
                                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                                <RadioGroup
                                                    row
                                                    value={progressChartType}
                                                    onChange={(e, value) => { setProgressChartType(value) }}
                                                >
                                                    <FormControlLabel value="progress-line" control={<Radio />} label="Progress Line" />
                                                    <FormControlLabel value="pie-chart" control={<Radio />} label="Pie Chart" />
                                                </RadioGroup>

                                            </div>
                                        </div>
                                        <div className="col-12 d-flex flex-column justify-content-start my-5">
                                            {
                                                progressChartType == 'progress-line' && selectedFundraisingCampaign && selectedFundraisingCampaign.campaignGoal &&
                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                    <LinearProgress color='success' variant="determinate" value={50} style={{ width: '95%' }} />
                                                    <Typography mx="2" variant="body1">50%</Typography>
                                                </div>
                                            }
                                            {
                                                progressChartType && progressChartType == 'pie-chart' && selectedFundraisingCampaign && selectedFundraisingCampaign.campaignGoal &&
                                                <div className="d-flex flex-row justify-content-center align-items-center">
                                                    <Doughnut data={{
                                                        labels: ['Person 1', 'Person 2', 'Left to raise'],
                                                        datasets: [
                                                            {
                                                                label: "Total raised",
                                                                backgroundColor: 'gray',
                                                                data: [15000, 10000, 25000]
                                                            }
                                                        ]
                                                    }} style={{ maxHeight: 300, height: 300 }} />
                                                </div>
                                            }
                                        </div>
                                        <div className="col-12 d-flex flex-row justify-content-center align-items-center m-3" style={{ zIndex: 100 }}>
                                            <Typography className="apply-font-header" style={{ marginRight: '15px' }}>Header font</Typography>
                                            <FontPicker
                                                pickerId='header'
                                                apiKey="AIzaSyCg21oXmAoyibzWODyqlA8AZwBDt7jJNic"
                                                activeFontFamily={headerSelectedFont ? headerSelectedFont.family : 'Open Sans'}
                                                onChange={async (nextFont) => {
                                                    console.log(nextFont)
                                                    setHeaderSelectedFont(nextFont)
                                                }}
                                                families={[
                                                    'Roboto', 'Open Sans', 'Montserrat', 'Poppins', 'Lato', 'Noto Sans', 'Fira Sans'
                                                ]}
                                            />
                                        </div>
                                        <div className="col-12 d-flex flex-row justify-content-center align-items-center m-3" style={{ zIndex: 99 }}>
                                            <Typography style={{ marginRight: '15px' }} className="apply-font-body">Body font</Typography>
                                            <FontPicker
                                                pickerId='body'
                                                apiKey="AIzaSyCg21oXmAoyibzWODyqlA8AZwBDt7jJNic"
                                                activeFontFamily={bodySelectedFont ? bodySelectedFont.family : 'Open Sans'}
                                                onChange={async (nextFont) => {
                                                    console.log(nextFont)
                                                    setBodySelectedFont(nextFont)
                                                }}
                                                families={[
                                                    'Roboto', 'Open Sans', 'Montserrat', 'Poppins', 'Lato', 'Noto Sans', 'Fira Sans'
                                                ]}
                                            />
                                        </div>
                                        <div className="col-12 d-flex flex-column justify-content-start p-5" style={{ fontFamily: 'Montserrat' }}>
                                            <RichTextEditor
                                                value={fundraisingCampaignDescription ? fundraisingCampaignDescription : EditorValue.createEmpty()}
                                                onChange={(e) => setFundrasingCampaignDescription(e)}
                                                rootStyle={{ minHeight: '300px' }}
                                                className="apply-font-body"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    layout == 'layout2' &&
                    <div className="row g-0 p-0">
                        <div style={{
                            backgroundColor: primaryColor && primaryColor.hex ? `#${primaryColor.hex}` : '#00C3A0',
                        }}>
                            <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Bebas+Neue"></link>
                            <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Montserrat"></link>
                        </div>
                        <div className="col-12">
                            <div className="sticky-top w-100 bg-white p-5 border rounded">

                            </div>
                            {
                                !changeHeaderImage ?
                                    <img
                                        src={headerImage ? headerImage : ''}
                                        style={{
                                            objectFit: 'cover',
                                            maxWidth: '100%',
                                            width: '100%',
                                            height: 300,
                                            opacity: 0.4,
                                        }}
                                        className="hover-overlay"
                                    />
                                    :
                                    <div {...headerImageRootProps({ className: 'dropzone h-100 w-100 d-flex flex-column justify-content-center align-items-center' })} style={{ minHeight: 300 }}>
                                        <input {...headerImageInputProps()} />
                                        {
                                            headerImageIsDragActive ?
                                                <p style={{ width: '100%', textAlign: 'center' }}>Drop the file here</p>
                                                :
                                                <p style={{ width: '100%', textAlign: 'center' }}>Drag an image here, or click to select a file.</p>
                                        }
                                    </div>
                            }
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    {
                                        !changeHeaderImage && !changeLogoImage ?
                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                <img
                                                    src={profileImage ? profileImage : ''}
                                                    style={{
                                                        objectFit: 'cover',
                                                        width: 250,
                                                        height: 250,
                                                        opacity: 1,
                                                    }}
                                                />
                                                {/* <Typography my="2" variant="h1" className="mx-4" style={{ color: 'black', fontSize: 70 }}>{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}

                                            </div>
                                            :
                                            !changeHeaderImage && changeLogoImage ?
                                                <div {...profilePictureRootProps({ className: 'dropzone h-100 w-100 d-flex flex-column justify-content-center align-items-center' })} style={{ minHeight: 100 }}>
                                                    <input {...profilePictureInputProps()} />
                                                    {
                                                        headerImageIsDragActive ?
                                                            <p style={{ width: '100%', textAlign: 'center' }}>Drop the file here</p>
                                                            :
                                                            <p style={{ width: '100%', textAlign: 'center' }}>Drag an image here, or click to select a file.</p>
                                                    }
                                                </div>
                                                :
                                                <div></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <ManageCampaignDialog visible={showManageCampaignDialog} onClose={() => setShowManageCampaignDialog(false)} />
        </div>
    )
}